InviteTab = App.loadClass "grower::handlers/contacts/tabs/Invite_Tab_Handler"

class exports.Remove_Permission_Dialog extends DialogHandler

    init: () ->
        @classes = 'medium_dialog'
        @layoutUrl = 'backend/grower/contacts/removepermissionform'
        @saveUrl = 'backend/grower/contacts/removepermission-ajax'
        @errorAction = () ->
            @dialog.find('.save-btn').addClass('hidden')
        @refreshNavHandler = false

        ## Update DDMs ##
        @successAction = (data) ->
            for i, v of App.current_page.activeSubHandlers
                if(v instanceof InviteTab)
                    $(v.layoutSelector).find('.btn-search').click() #re-run search
                else
                    App.current_page.refreshSubHandlers()

        @createDialog()

    afterLoadLayout: () ->
        ths = this
        @openDialog()

        ## Hide all elements's that shouldn't be visible ##
        @dialog.find('#affected-records').hide()
        @dialog.find('.div-replace-permission').hide()
        @dialog.find('.save-btn').hide()

        ## Set up Validation Engine ##
        @dialog.find('#frm_removepermission').validationEngine
            promptPosition: "centerRight"
            ajaxFormValidationMethod: "POST"

        ## Set up Save-btn Listener ##
        @submitAction = () =>
            valid = @dialog.find("#frm_removepermission").validationEngine('validate')
            if valid
                @save('Deleting Custom Permission... Assigning Replacement Permission...')

        ## Reveal / Hide Affected Records ##
        @dialog.find('#num-affected-btn').click( (e) ->
            e.preventDefault()
            btn = $(this)

            parentDiv = btn.parents('div')
            magicDiv = parentDiv.find('#affected-records')

                                            # This reduces the number of times we have to make the ajax request
            if( not btn.data('results') )     # when there is already results in the div, it just gets toggled
                                            # data-results is reset when the permission DDM is changed
                $.post(
                    'backend/grower/contacts/get-affectedrecords-ajax',
                    { 'permission_id': ths.dialog.find('.sel-remove-permission').val() },
                    (response) ->
                        if response.status?.type isnt 'success'
                            return

                        magicDiv.empty().append(response.view)
                        btn.data('results', 'true')
                        magicDiv.toggle('fast')     #this ensures the animation doesn't occur until the data is in the div
                )

            else
                magicDiv.toggle('fast')
        )


        ## Set up Permission DDM Listener ##
        @dialog.find('.sel-remove-permission').change( (e) ->
            if( not $(this).val() )
                ths.dialog.find('.div-replace-permission').hide('fast')
                ths.dialog.find('.save-btn').hide('fast')
                return
            #set loading message
            $.post('backend/grower/contacts/get-permissionremovalinfo-ajax',
                { 'permission_id': $(this).val() },
                (json) ->

                    resultsDiv = ths.dialog.find('.div-replace-permission')

                    if (json.status.type is 'error')
                        resultsDiv.replaceWith(json.status.msg)
                    else

                        #Alter affected records appropriately
                        resultsDiv.find('#affected-records').hide('fast').empty()
                        numAffectedBtn = resultsDiv.find('#num-affected-btn')
                        numAffectedBtn.removeData('results')  #will cause get-affectedrecords-ajax to run again
                        if(json.data.num_affected is '0')
                            numAffectedBtn.addClass('disabled')
                            numAffectedBtn.attr('disabled', 'disabled')
                        else
                            numAffectedBtn.removeClass('disabled')
                            numAffectedBtn.removeAttr('disabled')

                        #Update the Num affected, save-btn, etc.
                        resultsDiv.show('fast')
                        resultsDiv.find('.num-affected').empty().append(json.data.num_affected)
                        if(json.data.num_affected isnt '1')
                            resultsDiv.find('.word-contact').empty().append('contacts')
                        else
                            resultsDiv.find('.word-contact').empty().append('contact')
                        resultsDiv.find('.seldiv-replace-permission').empty().append(json.data.select)
                        ths.dialog.find('.save-btn').show('fast')
            )
        )
